<template>
    <SlideProductsDesktop v-if="block.platform == 1" :block="block" :border-width="borderWidth" :numeration="true"/>
    <SlideProductsMobile v-else :block="block" :numeration="true"/>
</template>
<script>
import SlideProductsDesktop from '../../Desktop/Blocks/SlideProducts';
import SlideProductsMobile from '../../Mobile/Blocks/SlideProducts';
import HomeBlock from '@/models/home-block';
export default {
    components:{
        SlideProductsDesktop,
        SlideProductsMobile,
    },
    props:{
        block:{
            type: HomeBlock
        },
        borderWidth:{
            type: Number,
            default: 2
        },
    }
}
</script>